import { assert } from '@ember/debug';
import { computed } from '@ember/object';

/**
 * Returns a computed property that reads from a CSS custom property on `this.element`.
 *
 * @function cssNumericalProperty
 * @param {String} name the name of the CSS property to read
 * @returns {Function} a computed property to assign to your Ember component
 */
export default function cssNumericalProperty(name) {
  return computed('element', function () {
    const value = getComputedStyle(this.element).getPropertyValue(name);
    assert('cssNumericalProperty requires a string containing a number value', value && value.toString().trim().match(/\d+\.?\d*/));
    return Number.parseFloat(value);
  });
}